module.exports = __webpack_public_path__ + "static/img/womanslg.c00b3cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/womanslg.jpg
// module id = Lk7u
// module chunks = 1